<template>
  <div class="home h-100">
    <!-- Navigation -->
    <Navbar />
    <section class="hero-header h-100">
      <div class="container">
            <div class="description text-center">
                <h1 class="policy">Coralstone Privacy Policy</h1>
            </div>
        </div>
    </section>

    <!-- why work with us -->
    <section class="privacy">
      <div class="container">
        <div class="row">
          <div class="col-md-4 order-2 order-md-1">
              <div class="sidebar-left">
                <ul class="list-unstyled">
                  <li><a href="#introductions" class="nav-link">Introductions</a></li>
                  <li><a href="#collect" class="nav-link">What we collect</a></li>
                  <li><a href="#personalInformation" class="nav-link">Why we collect your personal information</a></li>
                  <li><a href="#informationGather" class="nav-link">What do we do with the information we gather?</a></li>
                  <li><a href="#howCollectInformation" class="nav-link">How we collect personal information</a></li>
                  <li><a href="#doUseCookies" class="nav-link">Do we use Cookies?</a></li>
                  <li><a href="#howUseCookies" class="nav-link">How We Use Cookies</a></li>
                  <li><a href="#linkToWebsites" class="nav-link">Links to other websites</a></li>
                  <li><a href="#controlPersonalInfo" class="nav-link">Controlling your personal information</a></li>
                  <li><a href="#protectInfo" class="nav-link">How we protect your information</a></li>
                  <li><a href="#rententionInfo" class="nav-link">Retention of your personal information</a></li>
                  <li><a href="#sharingInfo" class="nav-link">Sharing your personal information</a></li>
                  <li><a href="#dataSubject" class="nav-link">Your Rights as a Data Subject</a></li>
                  <li><a href="#amendmentPolicy" class="nav-link">Amendments to Privacy Policy
</a></li>
                  <li><a href="#regulators" class="nav-link">Compliance with the Regulators</a></li>
                  <li><a href="#contact" class="nav-link">Contact</a></li>
              </ul>
              </div>
          </div>
          <div class="col-md-8 order-1 order-md-2">
            <div class="main-text">
                <div class="content" id="introductions">
                    <h3>Introductions</h3>
                    <p>Coralstone Capital Limited (hereinafter called “Coralstone Capital”/ “We”/ “Our”) treats personal information of users (“Users”/ “You”/ “Your”) of Coralstone Capital Website “coralstone.capital”  (hereinafter called the “Site”) as private and confidential.</p>

                    <p>This Privacy Policy (“Policy”) describes what personal information Coralstone Capital collects, what Coralstone Capital does with it, how Coralstone Capital protects it and how Coralstone Capital maintains information collected from Users of the Site.</p>

                    <p>This Policy applies to usage of the Site as well as information contained on the Site, particularly, information related to products and services offered by Coralstone Capital.</p>

                    <P>Coralstone Capital is committed to ensuring that Your privacy is protected. Should We ask You to provide certain information by which You can be identified when using this Website, then You can be assured that it will only be used following this Policy.
                    </p>
                </div>

                <div class="content" id="collect">
                    <h3>What we collect</h3>
                    <p>We may collect the following information:</p>

                    <ul>
                      <li>Personal identification information – We collect and use information about You to administer Our business. Information collected shall include</li>
                      <li>Your contact information such as name, contact address, email addresses, gender, and telephone numbers and details of next of kin;</li>
                      <li>Demographic information;</li>
                      <li>Occupation, Career history, professional background and other CV related information;
                      </li>
                      <li>International and National passport, driving license or any other form of proof of identification;</li>
                      <li>Transactional data, including financial details, your photograph; and</li>
                      <li>And any other information We may deem necessary and which may be determined by extant Nigerian laws and regulations.</li>
                    </ul>

                    <p>We may collect personal identification information from you in a variety of ways, including, but not limited to, when you visit our Site, register on the Site, make payments for our products and services, subscribe to Our newsletter, respond to a survey, or fill out a form, and in connection features or resources made available on our Site.</p>

                     <ul>
                      <li>Non-personal identification information – This is information received whenever You interact with Our Site. Non-personal identification information may include:</li>
                      <li>Unique IDs such as your mobile device identifier or cookie ID on your browser;</li>
                      <li>IP address and information that may be derived from the IP address, such as geographic location; and</li>
                      <li>Information about a device you use, such as browser, device type, operating system and the internet service providers utilized.
                      </li>
                    </ul>
                    <p>Other information relevant to customer surveys and/or offers</p>
                </div>

                <div class="content" id="personalInformation">
                    <h3>Why we collect your personal information</h3>
                    <p>All personal information which we collect and the process is justified by lawful processing on the basis that:</p>

                    <ul>
                      <li>You have given consent to the processing;</li>
                      <li>Processing is necessary for the performance of a contract to which you are a party or take steps to enter into a contract;</li>
                      <li>Processing is necessary for compliance with legal and regulatory obligations to which we are subject;</li>
                      <li>Processing is necessary to protect your vital interests or another natural person; and
                      </li>
                      <li>Processing is necessary for the performance of a task carried out in the public interest.</li>
                    </ul>

                   
                </div>

                 <div class="content" id="informationGather">
                    <h3>What do we do with the information we gather?</h3>
                    <p>We require this information to understand your needs, and provide you with better service, particularly concerning the following:</p>
                    <p>Internal record keeping;</p>

                    <ul>
                      <li>To respond to your enquiries about Coralstone Capital;</li>
                      <li>To improve our products and services;</li>
                      <li>To improve customer service delivery;</li>
                      <li>To send promotional emails about new products, special offers or other information which we think you may find interesting using the email address which you have provided;
                      </li>
                      <li>To contact you occasionally for market research purposes. We may contact you by email, phone, fax or mail;</li>
                      <li>To deliver technical and functional management on our site;</li>
                      <li>To provide specific services following an agreement you are entering, or have entered into with us;</li>
                      <li>To manage the security of our sites, networks and systems;</li>
                      <li>To comply with applicable laws and regulations and to operate our business;</li>
                      <li>To run a promotion, contest, survey or other site features; and</li>
                      <li>To improve our Site through feedback you provide on our products and services.</li>
                    </ul>
                    <p>Coralstone Capital will not share with other parties, information which you may provide when using the Site, except to the extent necessary to provide services to you, further to obtaining your consent.</p>
                   
                </div>

                <div class="content" id="howCollectInformation">
                    <h3>How we collect personal information</h3>
                    <p>We collect information about you and any other party whose details you provide to us when you:</p>
                    
                    <ul>
                      <li>To improve our Site through feedback you provide on our products and services;</li>
                      <li>Complete online forms;</li>
                      <li>Take part in surveys;</li>
                      <li>Interact with us using our social media platforms;
                      </li>
                      <li>Download information such as publications or participate in any other interactive areas that appear on our website or portals;
</li>
                      <li>Contact us offline, for example by telephone, SMS, email, post or any other means of communication;</li>
                      <li>Access and use any of our websites or portals from your devices (including mobile devices) and applications; and</li>
                      <li>Share information with third parties that are entitled to share that information, but in each case as permitted by applicable laws.</li>
                    </ul>
                </div>
                 <div class="content" id="doUseCookies">
                    <h3>Do We use Cookies?</h3>
                    <p>We use cookies to improve your browsing experience on our website. By browsing on our website, you consent to our use of cookies following our privacy policy.</p>
                    
                    <p>About Cookies</p>
                    <p>Cookies are a kind of short-term memory for the web. They are stored in your browser and enable a site to ‘remember’ little bits of information between pages or visits. Cookies can be used by web servers to identify and track users as they navigate different pages on a website, and to identify users returning to a website. Cookies may be either “persistent” cookies or “session” cookies. A persistent cookie consists of a text file sent by a web server to a web browser, which will be stored by the browser and will remain valid until its set expiry date (unless deleted by the user before the expiry date). A session cookie, on the other hand, will expire at the end of the user session, when the web browser is closed.</p>
                    <p>Our Website cookies</p>
                    <p>We use both session cookies (which expire once you close your web browser) and persistent cookies (which stay on Your device until you delete them). We need the cookies to enable the technical performance of Our websites and allow us to ‘remember’ the choices you make and your preferences (Functionality) and to allow us to collect certain information about how You navigate the Sites (Performance/Analytical).</p>
                </div>
                <div class="content" id="howUseCookies">
                    <h3>How We Use Cookies</h3>
                    <p>Cookies do not contain any information that personally identifies You, but personal information that We store about You may be linked, by us, to the information stored in and obtained from cookies. The cookies used on Our website include those which are strictly necessary for access and navigation, cookies that track usage (performance cookies) and those used to remember your choices (functionality cookies). We may use the information We obtain from Your use of our cookies for the following purposes:</p>
                    <ul>
                      <li>To provide you with a better website experience by enabling us to monitor which pages You find useful and which you do not;</li>
                      <li>To recognise Your computer and track you when You visit Our website; and</li>
                      <li>To analyse the use of Our website – such as how many people visit us each day.</li>
                    </ul>
                    
                    <p>Third-party Cookies</p>
                    <p>Our website uses cookies provided by trusted third-party such as Google Analytics, which is one of the most widespread and trusted analytics solutions on the web. This helps us to understand how You use the site and ways that We can improve Your experience.</p>
                    <p>Accepting, Declining and Disabling Cookies</p>
                    <p>You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but You can usually modify your browser setting to decline cookies if you prefer. However, this may prevent you from taking full advantage of the website. You can also disable cookies if You wish. However, this will affect the functionality of Our website and many other websites that You visit. Disabling cookies will usually result in also disabling certain functionality and features of this site. Therefore, it is recommended that you do not disable cookies.</p>
                    <p>By this, we can understand which parts of Our websites are interesting to You and which are not, as well as what We can do to improve them.</p>
                </div>

                <div class="content" id="linkToWebsites">
                    <h3>Links to other websites</h3>
                    <p>Our Site may contain links to other websites of interest. However, once You have used these links to leave Our Site, You should note that We do not have any control over such websites. Therefore, We cannot be responsible for the protection and privacy of any information which You provide whilst visiting such websites and such websites are not governed by this Privacy Policy. You should exercise caution and review the privacy statement(s) applicable to the websites.</p>
                </div>

                <div class="content" id="controlPersonalInfo">
                    <h3>Controlling your personal information</h3>
                    <p>You may choose to restrict the collection or use of your personal information in the following ways:</p>
                    <ul>
                      <li>Whenever You are asked to fill in a form on the Site, the privacy policy link will be available. You can decide not to fill the form if you do not accept the terms of the policy;</li>
                      <li>If You have previously agreed to us using Your personal information for direct marketing purposes, You may change Your mind at any time by emailing us at support@coralstone.capital.</li>
                    </ul>
                    <p>We will not sell, distribute or lease Your personal information to third parties unless we have Your permission or are required by law to do so. We may use Your personal information to send You promotional information about third parties which We think You may find an interesting subject to your written permission to do so.</p>
                </div>

                <div class="content" id="protectInfo">
                    <h3>How we protect your information</h3>
                    <p>We are committed to ensuring that Your information is secure. To prevent unauthorised access or disclosure, We have put in place reasonable physical, electronic and managerial procedures to safeguard and secure the information We collect online.</p>
                    <p>In particular, We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized access, alteration, disclosure or destruction of Your personal transaction information and data stored on our Site.</p>
                    <p>Sensitive and private data exchange between the Site and its Users happens over a secured communication channel and is encrypted and protected. Transactions are also handled over a secure payment gateway. Also, Coralstone Capital has implemented appropriate technical, physical and organisational measures designed to protect personal information against accidental or unlawful destruction, accidental loss, damage, alteration, unauthorised disclosure or access, as well as all other forms of unlawful processing.</p>
                </div>

                <div class="content" id="retentionInfo">
                    <h3>Retention of your personal information</h3>
                    <p>We maintain personal information not longer than we need to use it in accordance with Coralstone Capital’s Data Retention Policy. In some circumstances, we may retain your personal information for longer periods if it is in accordance with regulatory, legal, tax or accounting obligations. Coralstone Capital has an established retention procedure that applies to records and information collected and stored. In all cases, where your information is no longer required or you request for deletion, we will ensure it is disposed of securely.</p>
                </div>

                <div class="content" id="sharingInfo">
                    <h3>Sharing your personal information</h3>
                    <p>We do not sell, trade, or rent Users personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates and advertisers for the purposes outlined above. We will not disclose Your personal information to anyone outside Coralstone Capital without Your consent to do so unless one of the following circumstances applies:</p>
                    <ol>
                      <li>With your consent<br>
                      We will share personal information with companies, organizations or individuals outside of Coralstone Capital when We have your consent to do so. We shall obtain your consent before sharing any sensitive personal information</li>
                      <li>For external processing<br>
                      We provide personal information to our affiliates or other trusted businesses or persons to process it for us, based on our instructions and in compliance with our Privacy Policy and any other appropriate confidentiality and security measures.</li>
                      <li>For legal reasons<br>
                      We will share personal information with companies, organizations or individuals outside of Coralstone Capital if we have a good-faith belief that access, use, preservation or disclosure of the information is reasonably necessary to:</li>
                    </ol>
                    <ul>
                      <li>meet any applicable law, regulation, such as the Nigeria Data Protection Regulation (NDPR), legal process or enforceable governmental request.</li>
                      <li>detect, prevent, or otherwise address fraud, security or technical issues.
                      protect against harm to the rights, property or safety of Coralstone Capital, our Users or the public as required or permitted by law.
                      </li>
                    </ul>
                </div>

                <div class="content" id="dataSubject">
                    <h3>Your Rights as a Data Subject</h3>
                    <p>At any point while we have or processing your data, You, the data subject, have the following rights:</p>
                    <ul>
                      <li>Right of Access – You have the right to request a copy of the information that We hold about you</li>
                      <li>Right of rectification – You have a right to correct data that We hold about You that is inaccurate or incomplete
                      </li>
                      <li>Right to be Erased/Forgotten – In certain circumstances You can ask for the data We hold about You to be erased from our records</li>
                      <li>Right to Restriction of Processing – Where certain conditions apply to have a right to restrict the processing</li>
                      <li>Right of portability – You have the right to have the data We hold about you transferred to another organisation (to be reused for Your purposes)</li>
                      <li>Right to Object – You have the right to object to certain types of processing such as direct marketing</li>
                      <li>Right to Object to automated processing, including profiling – You also have the right to be subject to the legal effects of automated processing or profiling</li>
                      <li>Right to Withdraw – You have the right to withdraw Your consent at any time</li>
                    </ul>
                </div>
                 <div class="content" id="amendmentPolicy">
                    <h3>Amendments to Privacy Policy</h3>
                    <p>We reserve the right to amend this Privacy Policy from time to time and at any time to reflect changes to our practices concerning the use of your personal information.  All amendments to this Privacy Policy will be posted on the website. Unless otherwise stated, the current version shall supersede and replace all previous versions of this Policy.</p>
                    
                </div>
               
                <div class="content" id="regulators">
                    <h3>Compliance with the Regulators</h3>
                    <p>This Privacy Policy is in line with the provisions of Nigeria Data Protection Regulation, 2019 (Regulation), a regulation which describes how organisations including Coralstone Capital must collect, handle and store personal information and applies regardless of whether data is stored electronically, on paper or on other materials.</p>
                    
                </div>

                 <div class="content" id="contact">
                    <h3>Contact</h3>
                    <p>For questions, concerns, comments and requests regarding this privacy policy, please contact us through the details below:</p>
                    <p>Email: support@coralstone.capital<br>
                    Call: +234 (0) 816 935 2843 +234<br>
                    Please note response will be shared within 30 days of receiving your feedback.
                    </p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer"
import Navbar from "../components/Navbar.vue";

export default {
  name: 'Home',
  components: {
    Navbar,
    Footer
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables/colors.scss";

  // hero header styles
  .hero-header {
      background-image: url("../../public/img/privacy-hero-header.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      padding-top: 10rem;

      .description {
          color: #fff;

          h1 {
              font-family: 'Poppins', sans-serif;
              font-weight: bold;
              font-size: 64px;
              line-height: 96px;
              letter-spacing: 0.02em;
          }

          p {
              font-family: 'Poppins', sans-serif;
              font-size: 22px;
              line-height: 32px;
              padding: 0 15rem;
              text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          }

          .policy {
            font-size: 56px;
          }
      }
  }

  // privacy styles
  
  .privacy {
    padding: 2rem 0 4rem;

    .sidebar-left {
        background: #D8DCF3;
        padding: 0.5rem;
        border-radius: 16px;

        li {
            .nav-link {
                color: #28283A;
                font-weight: 500;

                &:hover {
                  color: #2C3C90;
                }
            }
        }
    }

    .main-text {
      h3 {
        font-weight: bold;
        font-size: 28px;
        line-height: 28px;
        letter-spacing: 0.02em;
        color: map-get($colors, deep-blue);
        padding-top: 5.3rem;
      }

      p {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: px;
        color: #28283A;
      }

      #introductions {
        h3 {
          padding-top: 0;
        }
      }

    }
  }


  @media (min-width: 992px) and (max-width: 1199px) {
    .hero-header {
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 64px;
                line-height: 96px;
            }

            p {
                font-size: 22px;
                line-height: 32px;
                padding: 0 10rem;
            }
        }
    }

    .privacy {
      margin-top: -1rem;
    }

  }


  @media (min-width: 767px) and (max-width: 991px) {
    .hero-header {
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 52px;
                line-height: 76px;
            }

            p {
                font-size: 22px;
                line-height: 32px;
                padding: 0 5rem;
            }

            .policy {
              font-size: 38px;
            }
        }
    }

    .privacy {

      .main-text {
        h3 {
          font-size: 24px;
        }
      }
    }

    
  }

  @media (max-width: 767px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 42px;
                line-height: 57px;
            }

            p {
                font-size: 20px;
                line-height: 32px;
                padding: 0 3rem;
            }

            .policy {
              font-size: 34px;
            }
        }
    }

    

    .privacy {
      margin-top: -4rem;

      .main-text {
        h3 {
          font-size: 20px;
        }

         #introductions {
          h3 {
            padding-top: 4.3rem;
          }
        }
      }
    }

    

    
  }

  @media (max-width: 575px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");
        //padding-top: 6rem;

        .description {

            h1 {
                line-height: 46px;
            }

        }
    }

    
  }

  @media (max-width: 375px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");

        .description {

            h1 {
                font-size: 35px;
            }

            p {
                font-size: 17px;
                padding: 0 2rem;
            }
        }
    }

    
  }


</style>

